import { createContext, useCallback, useContext, useRef, useState } from "react";

const TabularContext = createContext(undefined);

export function TabularProvider({ children }) {
    const ref = useRef(null);
    const [helpShown, setHelpShown] = useState(false);
    const [columnWidthModalShown, setColumnWidthModalShown] = useState(false);

    const showHelp = useCallback(() => setHelpShown(true), []);
    const hideHelp = useCallback(() => setHelpShown(false), []);
    const openColumnWidthModal = useCallback(() => setColumnWidthModalShown(true), []);
    const closeColumnWidthModal = useCallback(() => setColumnWidthModalShown(false), []);

    return (
        <TabularContext.Provider
            value={{
                ref,
                helpShown,
                showHelp,
                hideHelp,
                columnWidthModalShown,
                openColumnWidthModal,
                closeColumnWidthModal,
            }}
        >
            {children}
        </TabularContext.Provider>
    );
}

export function useTabularContext() {
    const context = useContext(TabularContext);
    if (!context) {
        throw new Error("TabularContext must be used within TabularProvider");
    }
    return context;
}
